import { AFFILIATE_ENDPOINT, getAppEnv } from '@/constants';
import { GenerateLinkRequest, GenerateLinkResponse, ApiError } from '@/types';

/**
 * Helper to generate a fake response for offline/demo mode
 */
const generateMockResponse = (url: string, platform: string): GenerateLinkResponse => {
  const randomHash = Math.random().toString(36).substring(2, 11).toUpperCase();
  const mockShortUrl = platform === 'mercadolivre'
    ? `https://mercadolivre.com.br/sec/opt_${randomHash}`
    : `https://shopee.com.br/universal-link/${randomHash}`;

  return {
    original_url: url,
    short_url: mockShortUrl,
    platform: platform as any
  };
};

/**
 * Calls the unified backend function to generate the affiliate link.
 * Falls back to client-side simulation if the backend is unreachable (Offline/Demo Mode).
 */
export const generateAffiliateLink = async (
  request: GenerateLinkRequest,
  token?: string
): Promise<GenerateLinkResponse> => {
  if (getAppEnv() === "local") {
    console.warn("⚠️ API unavailable. Switching to Offline Mode.");
    return generateMockResponse(request.url, request.platform);
  }

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(AFFILIATE_ENDPOINT, {
    method: 'POST',
    headers,
    body: JSON.stringify(request)
  });

  const data = await response.json();

  if (!response.ok) {
    throw {
      status: response.status,
      message: data.message || 'Falha ao gerar o link.',
      error: data.error
    } as ApiError;
  }

  return data as GenerateLinkResponse;
};